// generated from 1_141_369 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const segmentMembershipFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("segment_membership_filter"),
  comparison_key: z.enum([
    "1", // 603_260 (52.85%)
    "2", // 538_109 (47.15%)
  ]),
  display_name: z.string(),
  // undefined: 512_161 (44.87%), defined 629_208 (55.13%)
  raw_value: common.objectId.optional(),
  value: z.object({
    // true 247 (0.02%), false 1_141_122 (99.98%)
    disabled: z.boolean(),
    id: common.objectId,
    value: z.string(),
  }),
  varies_by_app_group: z.literal(true),
});
